uniform sampler2D uMap;
varying float vCameraDistance;
varying vec3 vWorldPos;

uniform vec3 uBox1Min;
uniform vec3 uBox1Max;

bool insideAABB(vec3 p, vec3 bmin, vec3 bmax) {
  return all(greaterThanEqual(p, bmin)) && all(lessThanEqual(p, bmax));
}

void main() {
  vec2 uv = gl_PointCoord;
  vec4 texel = texture2D(uMap, uv);
  if (texel.r < 0.1) discard;

  // Cull snow inside exclusion boxes (e.g., cabin interior)
  if (insideAABB(vWorldPos, uBox1Min, uBox1Max)) {
    discard;
  }

  vec4 color = vec4(1.0, 1.0, 1.0, 1.0);

  float invZ = 1.0 / -vCameraDistance;
  float cameraFarAdjustment = smoothstep(0.0, 0.15, invZ);
  float cameraNearAdjustment = 1.0 - smoothstep(0.0, 0.3, invZ);
  color.a *= cameraNearAdjustment * cameraFarAdjustment * texel.r;
  color.a *= 0.2;

  gl_FragColor = color;
}


